<template>
  <div class="book">
    <div class="page left">
      <h1>此一流、二刀と名付くる事</h1>

      <div v-for="(block, index) in japaneseBlocks" :key="'ja-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>

    <div class="page right">
      <div class="video">
        <div class="video-container">
          <iframe :src="youtubeEmbedUrl" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <h2>此一流，名之曰「二刀」。</h2>

      <div v-for="(block, index) in chineseBlocks" :key="'zh-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
const youtubeEmbedUrl = "https://www.youtube.com/embed/视频ID";

const japaneseBlocks = [
  { kobun: "此一流、二刀と名付くる事", translation: "この流派を二刀と名づける事" },
  { kobun: "二刀と云出す所、武士は将卒ともにぢきに二刀を腰に付くる役也。", translation: "二刀の理を唱えるのは、武士というものは、武将・士卒の身分を問わず二刀を腰に帯びることが本分であるからである。" },
    { kobun: "昔は太刀・刀といひ、今は刀・脇指といふ。", translation: "古時には「二刀」を太刀と刀と称し、今は刀と脇差の組み合わせが一般的である。" },

  { kobun: "武士たるものの此両腰を持つ事、こまかに書顕はすに及ばず。", translation: "武士が二刀を帯びるのは当然のことであり、改めて詳述するまでもない。" },

  { kobun: "我朝におゐて、しるもしらぬも腰におぶ事、武士の道也。", translation: "我が国では、理由を知る知らぬにかかわらず、二刀を帯びることこそが武士の道とされている。" },

  { kobun: "此二つの利をしらしめんために、二刀一流といふなり。", translation: "二つの刀それぞれの利を広く伝えるために、「二刀一流」と名づけられたのである。" },

  { kobun: "鑓・長刀よりしては、外の物といひて、武道具のうち也。", translation: "鑓や長刀に比べると、太刀は『外の物』と呼ばれながらも、やはり武士の武具の一つとされている。" },

  { kobun: "一流の道、初心のものにおゐて、太刀・刀両手に持ちて道を仕習ふ事、実の所也。", translation: "我が流では、初心者であっても太刀と刀を両手に携えて修行することが、正しい稽古の在り方とされている。" },

  { kobun: "一命を捨つる時は、道具を残さず役にたてたきもの也。", translation: "命を投げ打つその時には、手元の道具すべてを余すことなく活用したいものである。" },

  { kobun: "道具を役にたてず、こしに納めて死する事、本意に有るべからず。", translation: "武具を用いることなく腰に収めたまま死ぬのは、決して本来の志すところではない。" },

  { kobun: "然れども、両手に物を持つ事、左右共に自由には叶ひがたし。", translation: "両手に武器を持ったとしても、左右を同じように自在に操るのは容易ではない。" },

  { kobun: "太刀を片手にてとりならはせんため也。鑓・長刀、大道具は是非に及ばず、刀・わき指におゐては、いづれも片手にて持つ道具也。", translation: "鑓や長刀といった大型の武器は両手で扱うのが常であるが、刀や脇差については、いずれも片手で持つことを前提とした武具である。" },

  { kobun: "太刀を両手にて持ちて悪しき事、馬上にてあしゝ、かけ走る時あしゝ。", translation: "太刀を両手で扱うのは、馬上や走りながらの戦闘では非常に不都合である。" },

  { kobun: "沼・ふけ・石原、さかしき道、人ごみにあしゝ。", translation: "沼地や湿地、石が多い場所や険しい道、あるいは人が密集する場面では、扱いにくく不都合である。" },

  { kobun: "左に弓・鑓を持ち、其外いづれの道具を持ちても、みな片手にて太刀をつかふものなれば、両手にて太刀をかまゆる事、実の道にあらず。", translation: "左手に弓や槍、その他いかなる道具を持つ場合であっても、太刀は片手で扱うのが本来のあり方であり、両手で構えるのは正道ではない。" },

  { kobun: "若し片手にて打ちころしがたき時は、両手にても打ちとむべし。手間の入る事にてもあるべからず。", translation: "片手で討ち取るのが困難であれば、両手で打ち止めてもよい。それほど手間がかかることではない。" },

  { kobun: "先づ片手にて太刀をふりならはせん為に、二刀として、太刀を片手にて振覚ゆる道也。", translation: "まず片手で太刀を自在に振れるようにするために、二刀を用い、太刀の片手操作を習得するというのが我が流の方法である。" },

  { kobun: "人毎に初而とる時は、太刀おもくて振しがたき物なれども、万初めてとり付くる時は、弓もひきがたし、長刀も振りがたし。", translation: "誰しも最初に太刀を手にすれば、その重さに振るうのが難しく感じられるものだが、それは太刀に限らず、弓も長刀も初めは思うように扱えないものである。" },

  { kobun: "いづれも其道具になれては、弓も力つよくなり、太刀もふりつけぬれば、道の力を得て振よくなる也。", translation: "いかなる武具であれ、使い慣れてくれば弓は力強く引けるようになり、太刀もまた、道理を得て自然と軽やかに振るえるようになる。" },

  { kobun: "太刀の道といふ事、はやくふるにあらず、第二水の巻にてしるべし。", translation: "太刀の道とは、ただ速く振ることではない。その理については、第二の『水の巻』を参照されたい。" },

  { kobun: "太刀はひろき所にてふり、脇差はせばき所にてふる事、先づ道の本意也。", translation: "太刀は広い空間での使用を前提とし、脇差は狭い場所で使うもの――これが剣の道の根本的な考え方である。" },

  { kobun: "此一流におゐて、長きにても勝ち、短きにても勝つ。", translation: "この流では、刀の長短に関わらず、いかなる状況でも勝利を得ることを旨としている。" },

  { kobun: "故によつて太刀の寸をさだめず、何にても勝つ事を得る心、一流の道也。", translation: "ゆえに太刀の長さにはこだわらず、どのような長さであっても勝利を得ることを目指すのが、この流の教えである。" },

  { kobun: "太刀一つ持ちたるよりも、二つ持ちてよき所、大勢を一人してたゝかふ時、又とり籠りものなどの時によき事有り。", translation: "太刀を一本だけ持つより、二本携える方が有利なのは、対多数の戦いや、屋内に立て籠もるような状況で特に効果を発揮するためである。" },

  { kobun: "かやうの儀、今委敷書顕はすに及ばず、一をもつて万を知るべし。", translation: "このような内容は、ここで細かく記す必要はない。一つを理解すれば、多くの理が見えてくるはずである。" },

  { kobun: "兵法の道おこなひ得ては、一つも見へずといふ事なし。能々吟味あるべき也。", translation: "兵法の道を極めていけば、理解できないことは何一つない。深く吟味し、真意を汲み取るべきである。" },

];


const chineseBlocks = [
  { kobun: "此一流，名之曰「二刀」。", translation: "这个流派，被称为「二刀流」。" },
  { kobun: "主张二刀之理者，以武士无论尊卑，佩二刀于腰，乃其本职也。", translation: "主张二刀之理，是因为武士无论阶级高低，佩戴二刀本就是其本分与职责。" },
  {kobun: "昔称太刀与刀，今则谓之刀与脇指。",translation: "古时候人们称二刀为太刀与刀，如今则称为刀与脇差。"},
  { kobun: "武士佩此二刀者，理所当然，不必繁述。", translation: "武士佩戴这两把刀是理所当然的事情，无需多作说明。" },
  { kobun: "我朝之世，不论知其理与否，佩二刀于腰者，皆为武士之道也。", translation: "在我国，无论是否明白其中的道理，佩戴二刀都是武士的行为准则。" },
  { kobun: "欲使人知二刀之利，故称曰二刀一流。", translation: "为了让人了解这两把刀各自的优势，因而将其称为『二刀一流』。" },

  { kobun: "较之鑓与长刀，虽称太刀为外物，然亦列于武具之内。", translation: "与枪与长刀相比，虽称太刀为“外之物”，但它仍属于武士所用的武器之一。" },
  { kobun: "吾之一流之道，即初心之人，亦以两手执太刀与刀而修之，此乃正法也。", translation: "在我这一流派中，即使是初学者，也要双手持太刀与刀进行修练，这才是真正的修行方式。" },
  { kobun: "当舍此一命时，当尽用所有兵器，不可遗留。", translation: "当舍弃性命之时，应将所有武器毫无保留地发挥其作用。" },
  { kobun: "未尽其用，藏器而死，非本志也。", translation: "未曾发挥武器之用而将其束于腰间就死去，这绝非武士的本意。" },
  { kobun: "然执兵于两手，欲左右皆能自由挥使，实为难事。", translation: "即便双手持武器，要使左右之手都能自由灵活地运用，也是十分困难的。" },
  { kobun: "为习太刀之片手操用也。镰与长刀，此等大道具固宜双手，然刀与胁指，皆为片手所执之器也。", translation: "这是为了练习以单手使用太刀。像枪、长刀这类大武器自然需用双手，而刀与胁差，则本就是为单手持用而设计的武器。" },
  { kobun: "太刀以双手执之，则于马上战斗、奔行之间，皆为不便也。", translation: "太刀若需双手持用，在马上或奔跑时使用非常不便。" },
  { kobun: "沼泽、湿地、石原、险道及人群拥挤之处，皆不便也。", translation: "在沼泽、湿地、乱石地、险峻小道或人多拥挤的地方，都很难施展，十分不利。" },
  { kobun: "左执弓镰，或持他器，皆当片手运太刀，故双手架太刀者，非正道也。", translation: "左手持弓或枪，或携带其他器具时，太刀皆应以单手运用，因此双手持太刀并非正宗之法。" },
  { kobun: "若片手难以斩杀，则亦可用双手止敌，盖非繁难之事也。", translation: "如果用单手难以制敌，那也可以使用双手将其击退，这并不是什么麻烦的事。" },
  { kobun: "先习太刀之片手挥用，故以二刀之法，使习者得片手挥太刀之术，是为吾流之道也。", translation: "为了先练习用单手挥动太刀的技巧，我流采用二刀之法，让修行者掌握太刀的单手操作方式，这就是我们流派的训练方法。" },
  { kobun: "人初执太刀，多觉其重而难挥，然万事初起，如弓难张，长刀亦难挥也。", translation: "人们在初次拿起太刀时，常觉得太重难以挥动，但这并非太刀独有，任何事物初学时，弓难拉，长刀也难挥。" },
  { kobun: "凡器物既熟，则弓能劲引，太刀习久，得道之力，自能挥洒如意。", translation: "无论哪种兵器，一旦熟练，弓便能强劲拉开，太刀也因掌握其理，自然能挥动自如。" },
  { kobun: "所谓太刀之道，非徒速振可得也，其理详于第二《水之卷》，可观而知。", translation: "太刀之道，并不是只要挥得快就行了，具体的道理可参考第二篇《水之卷》来理解。" },
  { kobun: "太刀用之于广处，脇差施之于隘地，此乃剑道之本义也。", translation: "太刀适用于开阔之地，而脇差则用于狭窄之所，这正是剑道的基本理念。" },
  { kobun: "吾之一流，无论刀之长短，皆可取胜。", translation: "在我这一流派中，无论使用长刀还是短刀，都应能取胜。" },
  { kobun: "故我流不拘太刀之寸，长短皆能取胜，是为一流之道。", translation: "因此我这一流派不拘泥于太刀的长度，能够无论长短皆得胜，才是这门流派的核心精神。" },
  { kobun: "较之一刀，双刀之利，在于一人敌众，或闭守屋内之时，尤为有用。", translation: "相比只持一把刀，使用双刀在一人对抗多数或屋内闭守等情境下，更具优势。" },
  { kobun: "此等事理，无须尽述，知一可知万也。", translation: "这类事情不必在此详述，只要理解其中一理，便能以一知万。" },
  { kobun: "兵法之道，若能勤修，无有一事不可明。务当深思细研也。", translation: "只要精修兵法之道，没有任何一事是无法理解的，必须认真思考、深入体会。" },
];

</script>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>
